import React, { useEffect, useRef, useState } from "react";
import { BackArrowIcon, BreadcrumbIcon } from "../../Icons";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ResourceSidebar_N from "./ResourceSidebar_N";
import ResourceListPanel_N from "./ResourceListPanel_N";
import AssignButton from "../ResourceManagement/AssignButton";
import {
  ALL, APPLICATION_TAB_TYPE, AR_CONTENT_TAB, RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB
} from "../../constant/constants";
import ResourceFilter from "../ResourceManagement/ResourceFilter";
import { useDispatch } from "react-redux";
import { resetTotalCount } from "../../store/slice/filterOptions";


const { BackButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const ResourceManagement_N = ({ isMobileView }) => {
  const dispatch = useDispatch();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const navigate = useNavigate();
  const { type } = useParams();
  const { state } = useLocation();
  const locationSelectedData = state?.selectedData?.items || [];
  const [activeTab, setActiveTab] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const [selectedResource, setSelectedResource] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: []
  });

  const [checkBox, setCheckBox] = useState({
    [RESOURCE_APPLICATION_TAB]: false,
    [RESOURCE_MODULE_TAB]: false,
    [RESOURCE_ENVIRONMENT_TAB]: false,
    [RESOURCE_SKILL_STREAM_TAB]: false,
    [RESOURCE_SKILL_SCHOOL_TAB]: false,
    [AR_CONTENT_TAB]: false,
  });

  const [checkBoxAll, setCheckBoxAll] = useState({
    [RESOURCE_APPLICATION_TAB]: false,
    [RESOURCE_MODULE_TAB]: false,
    [RESOURCE_ENVIRONMENT_TAB]: false,
    [RESOURCE_SKILL_STREAM_TAB]: false,
    [RESOURCE_SKILL_SCHOOL_TAB]: false,
    [AR_CONTENT_TAB]: false,
  });

  const [search, setSearch] = useState({
    [RESOURCE_APPLICATION_TAB]: "",
    [RESOURCE_MODULE_TAB]: "",
    [RESOURCE_ENVIRONMENT_TAB]: "",
    [RESOURCE_SKILL_STREAM_TAB]: "",
    [RESOURCE_SKILL_SCHOOL_TAB]: "",
    [AR_CONTENT_TAB]: "",
  });

  const [checkedFilterItem, setCheckedFilterItem] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: [],
  });

  const backClick = (url) => {
    navigate(url || -1);
  };

  if (type && locationSelectedData.length === 0) {
    backClick(`/dashboard/${userData.user.uuid}`);
  }

  useEffect(() => {
    return () => {
      dispatch(resetTotalCount())
    }
  }, [])

  const handleResetSelectResource = () => {
    setSelectedResource({
      [RESOURCE_APPLICATION_TAB]: [],
      [RESOURCE_MODULE_TAB]: [],
      [RESOURCE_ENVIRONMENT_TAB]: [],
      [RESOURCE_SKILL_STREAM_TAB]: [],
      [RESOURCE_SKILL_SCHOOL_TAB]: [],
      [AR_CONTENT_TAB]: []
    });
    setCheckBox({
      [RESOURCE_APPLICATION_TAB]: false,
      [RESOURCE_MODULE_TAB]: false,
      [RESOURCE_ENVIRONMENT_TAB]: false,
      [RESOURCE_SKILL_STREAM_TAB]: false,
      [RESOURCE_SKILL_SCHOOL_TAB]: false,
      [AR_CONTENT_TAB]: false,
    });

    setCheckBoxAll({
      [RESOURCE_APPLICATION_TAB]: false,
      [RESOURCE_MODULE_TAB]: false,
      [RESOURCE_ENVIRONMENT_TAB]: false,
      [RESOURCE_SKILL_STREAM_TAB]: false,
      [RESOURCE_SKILL_SCHOOL_TAB]: false,
      [AR_CONTENT_TAB]: false,
    });
  };

  const handleOpenFilter = () => {
    setShowFilter(pre => !pre)
  }

  return (
    <>
      <div className="resource-page">
        {!isMobileView &&
          <BreadCrumb
            type={type}
            locationSelectedData={locationSelectedData}
            selectedResource={selectedResource}
            handleResetSelectResource={handleResetSelectResource}
            checkBoxAll={checkBoxAll}
            search={search}
            checkedFilterItem={checkedFilterItem}
          />
        }

        <div className="resource-body">
          <div className="resource-side">
            <ul className="uilist">
              <ResourceSidebar_N setActiveTab={setActiveTab} activeTab={activeTab} checkedFilterItem={checkedFilterItem} search={search} />
            </ul>
          </div>

          <div className="resource-details">
            <ResourceListPanel_N
              activeTab={activeTab}
              openFilter={handleOpenFilter}
              checkedFilterItem={checkedFilterItem}
              search={search}
              setSearch={setSearch}
              setSelectedResource={setSelectedResource}
              selectedResource={selectedResource}
              checkBox={checkBox}
              checkBoxAll={checkBoxAll}
              setCheckBox={setCheckBox}
              setCheckBoxAll={setCheckBoxAll}
            />
          </div>
        </div>

      </div>

      {activeTab &&
        <ResourceFilter
          showfilter={showFilter}
          openFilter={handleOpenFilter}
          activeTab={activeTab}
          checkedFilterItem={checkedFilterItem}
          setCheckedFilterItem={setCheckedFilterItem}
        />}
    </>
  );
};

export default ResourceManagement_N;

export const BreadCrumb = ({ type, locationSelectedData, selectedResource, handleResetSelectResource, checkBoxAll, search, checkedFilterItem }) => {
  const navigate = useNavigate();

  const backClick = (url) => {
    navigate(url || -1);
  };

  const { name: selectedItemName, avatar: selectedItemAvatar } = locationSelectedData.length ? locationSelectedData[0] : {};

  return (
    <>
      <div className="page-title with-fuctions">
        <div className="title-here">
          <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
          <div className="title-n-breads-wrapper">
            <div className="title-n-breads">
              <p>Resource Management</p>
              {type &&
                <>
                  <span className="separator"> {""} </span>
                  <div className="breadcrumbs">
                    <UserProfile profileUrl={selectedItemAvatar} name={selectedItemName} moreData={locationSelectedData.slice(1)} type={type} />
                  </div>
                </>
              }
            </div>
          </div>
        </div>

        <AssignButton
          selectedResource={selectedResource}
          handleResetSelectResource={handleResetSelectResource}
          checkBoxAll={checkBoxAll}
          search={search}
          checkedFilterItem={checkedFilterItem}
          locationSelectedData={locationSelectedData}
        />

      </div>
    </>
  )
}

export const UserProfile = ({ profileUrl, name, moreData, type }) => {

  const [error, setError] = useState(false);

  const getInitials = (fullName = "") => {
    return fullName.split(" ").slice(0, 2).map(e => e.charAt(0)).join("").toUpperCase();
  };

  return (
    <>
      <span className="active">
        {(error || !profileUrl) ?
          <div className="bread-user-avatar">
            <span className="bread-user-avatar-placeholder">{getInitials(name)}</span>
          </div>
          :
          <div className={`bread-user-avatar ${type === "groups" ? "group" : ""}`}>
            <img
              src={profileUrl}
              alt={name}
              onError={() => setError(true)}
            />
          </div>
        }
        <p>{name} {moreData.length > 0 && `+ ${moreData.length}`} </p>
      </span>
    </>
  )

}